<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
			v-for="(type,index) in newstypeList"
            class="content-nav-btn"
            :class="{'content-nav-active':type.id == newstype}"
            @click="newstypeChange(type)"
          >
            <span>{{type.name}}</span>
          </div>
        </div>

        <div class="content-nav-item">

          <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <div class="item-img" v-lazy:background-image="item.cover"></div>
            <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.id }}"
              >
            <p class="item-list-title">{{limitLength(item.title)}}</p>
            <p class="item-list-content">{{item.remark}}</p>
            <div class="item-list-more">             
                <img src="../assets/img/sanjiao.png" />
                <span>查看详情</span>
            
            </div>
          </router-link>
          </div>
        </div>
		<div style="margin:15px auto;">
			<el-pagination
			  style="text-align: center;"
			  :current-page="pageInfo.curPage"
			  :page-sizes="[9, 18, 27]"
			  :page-size="pageInfo.pageSize"
			  background
			  layout="total, sizes, prev, pager, next, jumper"
			  :total="pageInfo.total"
			  @size-change="handleSizeChange"
			  @current-change="handleCurrentChange"
			/>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
	  pageInfo: {
	    curPage: 1,
	    pageSize: 9,
	    total: 100
	  },
      newsList: [],
      newstype: '',
	  newstypeList: []
    };
  },
  watch: {
	  '$route': {
		  handler(newVal) {
			  if(newVal.query.id) {
				  this.newstype = newVal.query.id
				  this.pageInfo.curPage = 1
				  this.getListByPage()
			  }
		  }
	  }
  },
  methods: {
	  limitLength(data){
	  	if (!data) {
	  		return ''
	  	}
		if(data.length>30){
			return data.slice(0,30)+"..."
		}else{
			return data
		}
	  },
	  async initPage(){
		await this.getAllList()
		await this.getListByPage()
	  },
	  async getAllList(){
		// await this.$http.post('/oa/newcms/category/getChildById',{parentId:"a1fbc39c-1969-4e0d-bca1-4304d3b0e52e"})
		// .then(response => {
		// 	this.newstypeList = response.data.result
		// 	!this.newstype ? this.newstype = this.newstypeList[0].id : ''
		// 	// console.log(response)
		// })
		// .catch(error=> {

		// })
		const {data : { result }} = await this.$http({
			method: 'post',
			url: this.$baseURL + '/base/dict/getDataList',
			data: {
				dictCode: 'articleType'
			}
		})
		const newstypeList = result[0].children
		this.newstypeList = newstypeList.map(item => {
			return {
				id: item.id,
				name: item.dictName
			}
		})
		!this.newstype ? this.newstype = this.newstypeList[0].id : ''
	  },
	  newstypeChange(type){
		  const toPath = '/news?id=' + type.id
		  const currentPath = this.$route.fullPath
		  if(toPath !== currentPath) {
			  this.$router.push({
				 name: 'news',
				 query:{
				  id:type.id
				 }
			  })
		  }
	  },
	async getListByPage(){
		var curPage = this.pageInfo.curPage
		var pageSize = this.pageInfo.pageSize
		var category = this.newstype
		// console.log(this.$qs.stringify({curPage,pageSize,category}))
		// await this.$http.post('/oa/newcms/article/getListByPage',{curPage,pageSize,category})
		// .then(response => {
		// 	this.newsList = response.data.result.data
		// 	this.pageInfo.total = Number(response.data.result.total)
		// 	// console.log(response)
		// 	// console.log(this.newsList)
		// })
		// .catch(error=> {

		// })
		const {data : { result }} = await this.$http({
			method: 'post',
			url: this.$baseURL + '/oa/newcmsArticle/getDataListByPage',
			data: {
				curPage,
				pageSize,
				category
			}
		})
		this.pageInfo.total = Number(result.total)
		this.newsList = result.records.map(item => {
			return {
				id: item.id,
				cover: item.cover,
				title: item.title,
				remark: item.remark
			}
		})
	},
    handleSizeChange(val) {
		this.pageInfo.pageSize = val
		this.pageInfo.curPage = 1
		this.getListByPage()
    },
    handleCurrentChange(val) {
		this.pageInfo.curPage = val
		this.getListByPage()
    }
  },
  async mounted() {
	await this.initPage()
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid #bd282b;

        &-btn {
			cursor: pointer;
			width: 50%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #e4e4e4;
			transition: all 0.2s;
        }

        .content-nav-active {
          background-color: #bd282b;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          // height: 350px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #f4f4f4;
          box-shadow: 3px 2px 14px #f2f2f2;
          padding: 15px 0px;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 128px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #232323;
            font-size: 18px;
            padding: 0 10px;
            margin: 20px 0 0 0;
            overflow: hidden;
            text-overflow: ellipsis;
            // border-left: 1px solid #15669e;
          }

          &-content {
            width: 93%;
            // height: 100px;
            font-size: 14px;
            color: gray;			
            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;			
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
            margin: 0 auto;
            margin-bottom: 20px;
          }

          &-more {
            width: 93%;          
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 0 auto;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #727272;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>
